import { NgModule } from '@angular/core';
import { AdminComponent } from './admin.component';
import { RouterModule, Routes } from '@angular/router';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { AdminTagsComponent } from './admin-tags/admin-tags.component';
import { NewTagComponent } from './admin-tags/new-tag/new-tag.component';
import { EditTagComponent } from './admin-tags/edit-tag/edit-tag.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SharedModule } from '../../../shared/shared.module';
import { MatDialogModule } from '@angular/material/dialog';
import { AdminCategoriesComponent } from './admin-categories/admin-categories.component';
import { EditCategoryComponent } from './admin-categories/edit-category/edit-category.component';
import { NewCategoryComponent } from './admin-categories/new-category/new-category.component';
import { AdminStoriesComponent } from './admin-stories/admin-stories.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatBadgeModule } from '@angular/material/badge';
import { FileManagerModule } from '../../components/file-manager/file-manager.module';
import { AdminFileManagerComponent } from './admin-file-manager/admin-file-manager.component';
import { AlertModule } from '../../../shared/components/alert/alert.module';
import { AdminCommentsComponent } from './admin-comments/admin-comments.component';
import { StoryTitleModule } from '../../../shared/components/story-title/story-title.module';
import { AdminUsersComponent } from './admin-users/admin-users.component';

const ANGULAR_MATERIAL_MODULES = [
  MatButtonModule, MatIconModule, MatCardModule,
  MatTooltipModule, MatMenuModule, MatFormFieldModule,
  MatInputModule, MatCheckboxModule, MatDialogModule,
  MatSlideToggleModule, MatBadgeModule
];

const CORE_MODULES = [CommonModule, ReactiveFormsModule];

const COMPONENTS = [
  AdminComponent,
  AdminDashboardComponent,
  AdminTagsComponent, NewTagComponent, EditTagComponent,
  AdminCategoriesComponent, NewCategoryComponent, EditCategoryComponent,
  AdminStoriesComponent,
  AdminFileManagerComponent,
  AdminCommentsComponent
];

export const admin_nav_path = {
  adminCategories: '/admin/categories',
  adminComments: '/admin/comments',
  adminFileManager: '/admin/file-manager',
  adminStories: '/admin/stories',
  adminTags: '/admin/tags',
  adminUsers: '/admin/users'
};

const routes: Routes = [
    { path: '', component: AdminComponent, children: [
        { path: '', component: AdminDashboardComponent, pathMatch: 'full' },
        { path: 'categories', component: AdminCategoriesComponent },
        { path: 'categories/:category_slug/edit', component: EditCategoryComponent },
        { path: 'comments', component: AdminCommentsComponent },
        { path: 'file-manager', component: AdminFileManagerComponent },
        { path: 'stories', component: AdminStoriesComponent },
        { path: 'tags', component: AdminTagsComponent },
        { path: 'tags/:tag_slug/edit', component: EditTagComponent },
        { path: 'users', component: AdminUsersComponent }
      ] }
];

@NgModule({
  declarations: [...COMPONENTS, AdminUsersComponent],
  imports: [
    RouterModule.forChild(routes), ...CORE_MODULES,
    ...ANGULAR_MATERIAL_MODULES, SharedModule,
    FileManagerModule, AlertModule, StoryTitleModule
  ],
  exports: [RouterModule]
})
export class AdminModule { }
